<template>
  <div class="result-item">
    <div class="card _margin-bottom-30">
      <div class="result-item-container">
        <div class="review-badge badge" v-if="data.switchOption == 'None'">Review Only</div>

        <div class="row">
          <div class="col-md-3 supplier">
            <supplier-logo :id="data.supplierId"></supplier-logo>
            <div class="badge-group _margin-top-10">
              <span class="badge" v-if="data.isGreen">Green</span>
              <span class="badge" v-if="data.hasCancellationFee">Exit Fee</span>
              <span class="badge" v-if="data.isFixed">Fixed</span>
              <span class="badge" v-if="data.hasPaperBilling">Paper Billing</span>
              <span class="badge" v-if="data.hasOnlineManagement">Paperless Billing</span>
              <span class="badge">{{ data.hasWarmHomeDiscount ? 'Warm Home Discount' : 'No Warm Home Discount' }}</span>

              <span class="badge payment">{{ capitalize(data.payMethod) }}</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="visible-sm _margin-top-20"></div>
            <h6 class="tariff-name">{{ data.tariffName }}</h6>
            <ul class="bullet-points">
              <li v-for="(item, index) in limitTo(3, data.tariffDetails, this.moreTariffDetails)" :key="index">
                {{ item }}
              </li>
            </ul>

            <small v-if="data.tariffDetails.length === 0">No Tariff Details</small>

            <div class="text-left _margin-top-10" v-if="data.tariffDetails.length > 3">
              <uiv-btn type="default" size="xs" @click="toggleOpen('moreTariffDetails')">
                {{ data.tariffDetails.length - 3 }} {{ moreTariffDetails ? 'less' : 'more' }}
              </uiv-btn>
            </div>

            <div class="visible-sm _margin-bottom-20"></div>
          </div>

          <div class="col-sm-6 col-md-2">
            <div class="row pricing">
              <div class="col-xs-6 col-sm-12 _margin-bottom-10">
                <p>Projected Annual Energy Cost</p>
                <h5>{{ data.totalCost | currency(2) }}</h5>
              </div>

              <div class="col-xs-6 col-sm-12">
                <p>{{ data.savings > 0 ? 'Saving' : 'Increased Cost' }} per Year</p>
                <h4 class="savings" :class="{ red: data.savings < 0, green: data.savings > 0 }">
                {{ convertToPositive(data.savings) | currency(2) }}</h4>
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-3">
            <div class="row">
              <div class="col-xs-12" v-if="data.switchOption != 'None'">
                <uiv-btn type="primary" block size="md" class="action-button _margin-bottom-20"
                  @click="$emit('onChoose')">Switch Now</uiv-btn>
              </div>

              <div class="col-xs-12">
                <uiv-btn type="ghost" class="action-button" block size="xs" @click="$emit('onMore')">More Info</uiv-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SupplierLogo from '../../../../base/components/supplier-logo/SupplierLogo';

export default {
  name: 'ResultItem',
  data() {
    return {
      moreTariffDetails: false,
      showBreakdown: false,
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      months: ['January', 'Feburary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    };
  },
  props: {
    data: Object,
    type: String,
    isTou: Boolean
  },
  methods: {
    async toggleOpen(prop) {
      this[prop] = !this[prop];

      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Quote Results' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: `Show ${this[prop] ? 'More' : 'Less'}` });
      this.$store.dispatch('tracing/addAction', { name: 'Tariff Id', value: this.data.tariffId });
      await this.$store.dispatch('tracing/saveActions');
    },
    limitTo(limit, array, toggle) {
      if (!toggle) {
        return array.slice(0, limit);
      }

      return array;
    },
    convertToPositive(number) {
      return number < 0 ? -1 * number : number;
    },
    formatLetters(str, n) {
      return str.substring(0, n).toUpperCase();
    },
    capitalize(s) {
      if (!s) return '';
      return s.replace(/([A-Z])/g, ' $1').trim();
    }
  },
  components: {
    SupplierLogo
  }
};
</script>

<style lang="scss" src="./result-item.scss"></style>
